// src/components/common/ConfirmDeleteDialog.jsx
import React from "react";
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
} from "@chakra-ui/react";
import Translate from "../LanguageTranslation/Translate"; // adjust relative path!

/**
 * Generic confirmation dialog.
 *
 * Props
 * ─────────────────────────────────────────────────────────────
 * isOpen      : boolean          // dialog visible?
 * onClose     : () => void       // close handler
 * onConfirm   : () => void       // confirm action
 * cancelRef   : React ref        // least-destructive ref
 * header      : string | node    // header text
 * message     : string | node    // body text
 */
const ConfirmDeleteDialog = ({
  isOpen,
  onClose,
  onConfirm,
  cancelRef,
  header = "Confirm Deletion",
  message = "Are you sure you want to delete this item? This action cannot be undone.",
}) => (
  <AlertDialog
    isOpen={isOpen}
    leastDestructiveRef={cancelRef}
    onClose={onClose}
    isCentered
    size={{ base: "sm", md: "md" }}
  >
    <AlertDialogOverlay>
      <AlertDialogContent>
        <AlertDialogHeader fontSize="lg" fontWeight="bold">
          <Translate text={header} />
        </AlertDialogHeader>

        <AlertDialogBody>
          <Translate text={message} />
        </AlertDialogBody>

        <AlertDialogFooter>
          <Button ref={cancelRef} onClick={onClose}>
            <Translate text="Cancel" />
          </Button>
          <Button colorScheme="red" onClick={onConfirm} ml={3}>
            <Translate text="Delete" />
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialogOverlay>
  </AlertDialog>
);

export default ConfirmDeleteDialog;
